/* eslint-disable no-global-assign */
// this is where the globals are defined
Academy = {};

// eslint-disable-next-line no-unused-vars
function $$(id) {
	return document.getElementById(id);
}

// Startup
$(function () {
	// Event handler for logout link.
	$("#header-logout, .logout-link").on("click", Academy.Logout.logout);

	Academy.fixFooter();
	Academy.login.initialize();
	Academy.initializePopIn();
	Academy.isVirtual = !!Academy.campus && Academy.campus.id === "virtual";
	if (Academy.campus) {
		Academy.campus.isVirtual = Academy.isVirtual;
	}

	// Handle unimitate button
	// Note: This is duplicated in academy.js and base.js because
	// I'm not sure if there's a single js file that loads on every page.
	$(".unimitate-btn").click(function (e) {
		$.ajax({
			url: "/ajax.php",
			timeout: 5000,
			type: "post",
			data: {
				a: "unimitate",
			},
			success: function () {
				window.location.reload();
			},
		});
	});
});

// Currently unused
Academy.clearQuery = function (list) {
	if (Object.prototype.toString.call(list) !== "[object Array]") {
		list = ["utm_source", "gtm_list"];
	}

	var parts = location.href.split("?");
	if (parts.length > 1) {
		var path = parts[0];
		var query = [];
		parts = parts[1].split("&");
		for (var i = 0; i < parts.length; i++) {
			var a = parts[i].split("=");
			if (a.length > 1) {
				if (list.indexOf(a[0]) < 0) {
					query.push(parts[i]);
				}
			} else {
				query.push(parts[i]);
			}
		}
		query = query.join("&");
		window.history.replaceState({}, document.title, path + "?" + query);
	}
};

/**
 * Get bootstrap data. Only valid for parent level keys
 * @param {string} key
 * @param {mixed} dflt
 * @returns {mixed}
 */
Academy.getBootstrapData = function (key, dflt) {
	if (Academy.bootstrap_data && Academy.bootstrap_data.hasOwnProperty(key)) {
		return Academy.bootstrap_data[key];
	}
	if (AoPS.bootstrap_data && AoPS.bootstrap_data.hasOwnProperty(key)) {
		return AoPS.bootstrap_data[key];
	}

	return dflt;
};

/**
 * Fix footer (and sidebar!) for pages which are short
 */
Academy.fixFooter = function () {
	// Determine minimum height of #main-content
	var height = $(window).height();
	var has_small = $("body").hasClass("small-footer");

	height -= $("#header-wrapper").outerHeight();
	height -= $("#top-bar").outerHeight();

	if (has_small) {
		height -= $("#small-footer-wrapper").outerHeight();
	} else {
		height -= $("#main-footer").outerHeight();
	}

	$("#main-content").css("min-height", height);

	if (has_small) {
		$("#small-footer-wrapper").show();
	}

	var sidebar = document.getElementById("side-column-wrapper");
	if (sidebar) {
		$(sidebar).css("min-height", height);
	} else {
		$("#main-content").css("padding-bottom", "35px");
	}
	$("#small-footer-wrapper").css("position", "absolute");
	$("#header-old,#header-old-ribbon").css("margin-bottom", 35);
	$("body").css("min-height", "100vh");
	$("body").css("position", "relative");
	$(sidebar).css("height", $(sidebar).closest(".left-navigation").height());
};

/**
 * Set up AoPS alerts
 */
window.classicAlert = window.alert;
window.alert = function (message, opts) {
	if (AoPS.hasOwnProperty("Ui")) {
		AoPS.Ui.Modal.closeTopModal();
		AoPS.Ui.Modal.showAlertQuick(message, opts);
	} else {
		window.classicAlert(message);
	}
};

window.classicConfirm = window.confirm;
window.confirm = function (message, opts, callback) {
	// Allow last two params in either order
	if (typeof opts === "function") {
		var temp = callback;
		callback = opts;
		opts = temp;
	}

	if (AoPS.hasOwnProperty("Ui")) {
		if (opts && (opts.yesNo || opts.yes_no)) {
			opts.confirm_button_ok = "Yes";
			opts.confirm_button_cancel = "No";
		}

		AoPS.Ui.Modal.showConfirmQuick(message, callback, opts);
	} else {
		// eslint-disable-next-line no-alert
		var result = confirm(message);
		callback(result);
	}
};

// TODO PLATFORM (POST LAUNCH): Combine the login/logout stuff in this file with base.js?
Academy.getSigninURL = function (opts = {}) {
	var redirectUrl = opts.redirectUrl ? opts.redirectUrl : window.location.href;
	return `/signin?requestedPage=${encodeURIComponent(redirectUrl)}`;
};

Academy.Logout = {
	logout: function (e) {
		window.location.href = `/signout?requestedPage=${encodeURIComponent(
			window.location.href
		)}`;
		return;
	},

	redirect: function (url) {
		window.location.href = `/signout?requestedPage=${encodeURIComponent(url)}`;
		return;
	},
};

Academy.login = {
	initialize: () => {
		$(".academy-login-button").on("click", Academy.login.display);
	},

	display: function (opts = {}) {
		window.location.href = Academy.getSigninURL(opts);
		return;
	},
};

Academy.initializePopIn = function () {
	var $body = $("body"),
		$top_bar = $("#top-bar"),
		$main_logo = $("#main-logo"),
		start_over_bar = false,
		over_bar = false,
		over_logo = false,
		scroll_time = 150,
		scroll_delay = 350,
		start_over_logo = false;

	/** Dealing with what to do if the cursor is at the top of the page on load.  Don't want the stuff to scroll
	 in right when they start moving.  This is particularly weird when user has just clicked to company pages **/
	$top_bar.on("mousemove.start_loc", function () {
		start_over_bar = true;
	});
	$main_logo.on("mousemove.start_loc", function () {
		start_over_logo = true;
	});
	$body.on("mousemove.start_loc", function () {
		$top_bar.off("mousemove.start_loc");
		$body.off("mousemove.start_loc");
		$main_logo.off("mousemove.start_loc");
		setTimeout(function () {
			start_over_bar = false;
			start_over_logo = false;
		}, 350);
	});

	$top_bar.on("mouseenter", function () {
		over_bar = true;
		setTimeout(function () {
			if (!start_over_bar && over_bar) {
				$("#header-popin").animate(
					{
						//					top : 0
						opacity: 1,
					},
					scroll_time
				);
			}
		}, scroll_delay);
	});

	$main_logo.on("mouseenter", function () {
		over_logo = true;
		setTimeout(function () {
			if (!start_over_logo && over_logo) {
				$("#header-popin").animate(
					{
						//					top : 0
						opacity: 1,
					},
					scroll_time
				);
			}
		}, scroll_delay);
	});

	$top_bar.on("mouseleave", function () {
		over_bar = false;
	});

	$main_logo.on("mouseleave", function () {
		over_logo = false;
	});

	$("#header").on("mouseleave", function () {
		$("#header-popin").animate(
			{
				//			top : '-30px'
				opacity: 0,
			},
			scroll_time
		);
	});
};

Academy.convertSmartQuotes = function (s) {
	return s
		.replace(/[\u2018\u2019]/g, "'")
		.replace(/[\u201C\u201D]/g, '"')
		.replace(/[\u2013\u2014]/g, "-")
		.replace(/[\u2026]/g, "...");
};

/**
 * Check if an element is visible in the viewport
 * @param {HTMLElement} element
 * @returns {boolean}
 */
Academy.isInViewport = function (element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

/**
 * Compile a handlebars template via dom, selector, or string.
 * If Handlebars is not loaded, do a simple search/replace.
 *
 * @param Element|jQuery|string dom May be an HTML element, jQuery object, DOM selector, or template.
 * @param Object data Data to embed in template
 * @return string
 */
window.handlebars = function (dom, data) {
	var text = "";
	if (!data) {
		data = {};
	}

	if (dom instanceof Element) {
		text = dom.innerHTML;
		// eslint-disable-next-line no-undef
	} else if (typeof jQuery !== "undefined" && dom instanceof jQuery) {
		text = dom.html();
	} else if (typeof dom === "string") {
		if (dom.substr(0, 1) === "." || dom.substr(0, 1) === "#") {
			var d = document.querySelector(dom);
			text = d === null ? dom : d.innerHTML;
		} else {
			text = dom;
		}
	} else {
		return false;
	}

	if (typeof Handlebars !== "undefined") {
		return Handlebars.compile(text)(data);
	}

	// Super simple search/replace
	for (var key in data) {
		var regex = new RegExp("{{" + key + "}}", "g");
		text = text.replace(regex, data[key]);
	}

	return text;
};
